import React from 'react';
import { Modal, Form, Input, Button } from 'antd';
import { RiCloseFill } from 'react-icons/ri';

const AssignRefereeModal = ({ visible, onCancel }) => {
    const [form] = Form.useForm();

    const handleSave = async () => {
        try {
            await form.validateFields();
            alert('Zuweisung gespeichert.');
            form.resetFields();
        } catch (errorInfo) {
            console.error('Failed to assign referee:', errorInfo);
        }
    };

    return (
        <Modal
            title="Schiedsrichter zuweisen"
            width={400}
            visible={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Abbrechen
                </Button>,
                <Button key="submit" type="primary" onClick={handleSave}>
                    Zuweisen
                </Button>,
            ]}
            closeIcon={<RiCloseFill className="remix-icon text-color-black-100" size={24} />}
        >
            <Form form={form} layout="vertical" name="assignRefereeForm">
                <Form.Item
                    label="Spiel-ID"
                    name="matchID"
                    rules={[{ required: true, message: 'Bitte Spiel-ID eingeben.' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Schiedsrichter-ID"
                    name="refereeID"
                    rules={[{ required: true, message: 'Bitte Schiedsrichter-ID eingeben.' }]}
                >
                    <Input />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default AssignRefereeModal;
